import { inject, Injectable, Signal } from '@angular/core';
import { AbstractTagEditorService } from '@iot-platform/iot-platform-ui';
import { TagCategory } from '@iot-platform/models/common';
import { Store } from '@ngrx/store';

import { AdminOrganizationsTagsPageActions } from '../features/admin-organizations/state/actions';
import * as fromOrganizations from '../features/admin-organizations/state/reducers';

@Injectable({
  providedIn: 'root'
})
export class TagEditorService extends AbstractTagEditorService {
  private readonly store: Store = inject(Store);

  getCategories(): Signal<TagCategory[]> {
    return this.store.selectSignal(fromOrganizations.getInEditModeTags);
  }

  getListTagsByOrganizationForEdition(organizationId: string, withParents: boolean, concept: string): void {
    this.store.dispatch(
      AdminOrganizationsTagsPageActions.listTagsByOrganizationForEdition({
        organizationId,
        withParents,
        concept
      })
    );
  }

  addTagToOrganization(tagToAdd: TagCategory): void {
    this.store.dispatch(AdminOrganizationsTagsPageActions.addTagToOrganizationForEdition({ tagToAdd }));
  }

  updateTagInOrganization(tagToUpdate: TagCategory): void {
    this.store.dispatch(AdminOrganizationsTagsPageActions.updateTagInOrganizationForEdition({ tagToUpdate }));
  }

  removeTagFromOrganization(tagToRemove: TagCategory): void {
    this.store.dispatch(AdminOrganizationsTagsPageActions.removeTagFromOrganizationForEdition({ tagToRemove }));
  }
}
